import React, {useState, useEffect} from 'react';
import styled from 'styled-components';
import {useParams} from 'react-router-dom';
import Slider from "react-slick";

// import AnalyticsService from './../../services/AnalyticsService';


import Container from './../../common/components/Container';
import Row from './../../common/components/Row';
import Col from './../../common/components/Col';
import Spacer from './../../common/components/Spacer';
import FullModal from './../../common/components/FullModal';
import Band from './../layout/Band';
import MainTitle from './../layout/MainTitle';
import SectionTitle from './../layout/SectionTitle';
import SubSectionTitle from './../layout/SubSectionTitle';
import Button from './../layout/Button';
import Layout from './../layout/Layout';
// import Section from './../layout/Section';
// import Typo from './../../common/components/Typo';
import Meta from './../layout/Meta';
import Header from './../layout/Header';
import Map from './../../map/Map';
import Docs from './Docs';

// import NewsletterAvailability from './../layout/NewsletterAvailability';

// import DatabaseService from './../../services/DatabaseService';

// import {LAYOUT_SM, LAYOUT_XS } from './../../config';
// import { act } from 'react-dom/test-utils';

import {DEMO_SITO} from '../../demodata';

const PARTI_MESE = 4;
const ARR_MONTHS = ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"];
const ARR_YEARS = [2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023];


const DescriptionBandLayer = styled.div.withConfig({displayName:'-DescriptionBandLayer'})`
  margin-top: -40px;
  padding: 40px 0px;
  background-color: #0D609DD4;
  color: #ffffff;
  text-align: left;
`;


const DocsFolder = styled.div.withConfig({displayName:'-DocsFolder'})`
  text-transform: uppercase;
  font-size: 1rem;
  font-weight: 700;
  color: #0D609D;
  cursor: pointer;
  &:hover{
    text-decoration: underline;
  }
`;
const DocsSubFolder = styled.div.withConfig({displayName:'-DocsSubFolder'})`
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.5rem;
  color: #0D609D;
  cursor: pointer;
  &:hover{
    text-decoration: underline;
  }
`;

const Gallery = styled.div.withConfig({displayName:'-Gallery'})`

  position: relative;
  width: calc(100vw - 88px);
  height: calc(100vh - 88px);

  & .slick-arrow{
    z-index: 999999;
    width: 44px;
    height: 44px;
  }

  & .slick-prev {
    left: -5px;
  }

  & .slick-next {
    right: -5px;
  }
`;

const GalleryImage = styled.div.withConfig({displayName:'-GalleryImage'})`
  width: calc(100vw - 88px);
  height: calc(100vh - 88px);

  background-image: url('${props=>props.src}');
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
`;



const Timeline = styled.div.withConfig({displayName:'-Timeline'})`
  background-color: #F1F1F1;
  padding: 30px 0px;
  margin: 0px 0px 30px;

  & .slick-prev:before, .slick-next:before{
    color: #0D609D;
  }
`;
const TimelineYear = styled.div.withConfig({displayName:'-TimelineYear'})`
  display: flex;
  flex-direction: row;
`;
const TimelineMonth = styled.div.withConfig({displayName:'-TimelineMonth'})`
  flex-basis: calc(100% / 12);
  border-left: 1px solid #aaaaaa;
`;
const TimelineParts = styled.div.withConfig({displayName:'-TimelineParts'})`
  height: 100px;
  display: flex;
  justify-content: space-around;
`;
const TimelinePart = styled.div.withConfig({displayName:'-TimelinePart'})`
  height: 100%;
  flex-basis: 25%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  cursor: pointer;

  &:not(:first-child){
    border-left: 1px solid #dedede;
  }
`;
const TimelineFill = styled.div.withConfig({displayName:'-TimelineFill'})`
  background-color: #0D609D;
  width: 100%;
`;
const TimelineMonthLabel = styled.div.withConfig({displayName:'-TimelineMonthLabel'})`
  color: #0D609D;
  font-weight: bold;
  font-size: 12px;
  padding-left: 5px;
  /* border-top: 1px solid #0D609D; */
`;

const TimelineIndex = styled.div.withConfig({displayName:'-TimelineIndex'})`
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
`;
const TimelineIndexItem = styled.div.withConfig({displayName:'-TimelineIndexItem'})`
  color: #0D609D;
  font-weight: ${props => props.active ? 700 : 300};
  font-size: 20px;
  cursor: pointer;  
`;



const Sites = ({layout}) => {
  // let { lang, slug } = useParams();
  let { slug } = useParams();

  const [showModalGallery, setShowModalGallery] = useState(false);
  const [showModalMap, setShowModalMap] = useState(false);
  const [showModalDoc, setShowModalDoc] = useState(false);

  const [timelineYear, setTimelineYear] = useState(2014);
  const [timelineSlider, setTimelineSlider] = useState(false);

  // useEffect(() => {
  //   AnalyticsService.init();  
  // }, []);

  useEffect(() => { 
    // DatabaseService.getEvents({
    //   status: "next",
    //   order: "asc"
    // }).then((response) => {
    //   if(response.success){
    //     setEventsNext(response.data);
    //   }else{
    //     console.log(response.error);
    //   }
    // });
  }, []);

  return (
    <Layout layout={layout}>
      <Meta
        title={"Area mineraria " + DEMO_SITO.name}
        description={DEMO_SITO.description}
        image={"https://www.cesi.it/assets/" + slug + ".png"}
        languages={{"it": "siti/"+slug}}
      />
      
      <Header 
        src={"/assets/sites-headers/"+slug+".jpg"} 
        title={"Area mineraria " + DEMO_SITO.name}
        lowerText={DEMO_SITO.location}
        cta={<Button variant="white-o" onClick={() => setShowModalGallery(true)}>Scopri la gallery completa</Button>}
      />
      {showModalGallery ? 
        <FullModal onClose={() => setShowModalGallery(false)}>
          <Gallery>
            <Slider 
              dots={false}
              infinite={false}
              arrows={true}
            >
              {[...Array(15).keys()].map((i) => 
                <GalleryImage 
                  key={i}
                  src={"/assets/sites-gallery/"+(i+1)+".jpg"} 
                />
              )}
            </Slider>
          </Gallery>
        </FullModal>
      : null}

      <Band>
        <Container>
          <MainTitle
            upperText={"Sito"}
            title={DEMO_SITO.name}
            lowerText={DEMO_SITO.location}
          />
          <span dangerouslySetInnerHTML={{__html: DEMO_SITO.description}} />
          <br />
        </Container>
      </Band>

      <Band background={"/assets/sites-maps/"+slug+".png"} align="center" variant="blue">
        <DescriptionBandLayer>
          <Container>
            <SectionTitle title={DEMO_SITO.mapTitle} variant="white" />
            <span dangerouslySetInnerHTML={{__html: DEMO_SITO.mapText}} />
          </Container>
        </DescriptionBandLayer>
        <Spacer height={"40vh"} />
        <Container>
          <Button onClick={() => setShowModalMap(true)}>Guarda la mappa</Button>
          {showModalMap ? 
            <FullModal onClose={() => setShowModalMap(false)}><Map /></FullModal>
          : null}
        </Container>
      </Band>

      <Band>
        <Container>
          <SectionTitle title={"Area gestione documenti"} variant="blue" />
          <br/>
          <SubSectionTitle title={"Timeline documentale"} variant="blue" />
        </Container>

        <Timeline>
          <Container>

            <Slider
              ref={slider => setTimelineSlider(slider)}
              beforeChange={(j, i) => setTimelineYear(ARR_YEARS[i])}
              infinite={false}
            >
              {ARR_YEARS.map(year => 
                <div key={year}> 
                  <TimelineYear>
                    {ARR_MONTHS.map(month => 
                      <TimelineMonth key={year+"-"+month}>
                        <TimelineParts>
                          {[...Array(PARTI_MESE).keys()].map((i) => {
                            
                            // $daystart = null;
                            // $dayend = null;
                            // switch($i){
                            //     case 0:
                            //       $daystart = 1;
                            //       $dayend = 7;
                            //       break;
                            //     case 1:
                            //       $daystart = 8;
                            //       $dayend = 14;
                            //       break;
                            //     case 2:
                            //       $daystart = 15;
                            //       $dayend = 21;
                            //       break;
                            //     case 3:
                            //       $daystart = 22;
                            //       $dayend = date("t", strtotime($year."-".sprintf('%02d', $kMonth+1)."-01"));
                            //       break;
                            // }
                            // $datestart = $year."-".sprintf('%02d', $kMonth+1)."-".sprintf('%02d', $daystart);
                            // $dateend = $year."-".sprintf('%02d', $kMonth+1)."-".sprintf('%02d', $dayend);
                            // TimelinePart: <a class="part" data-type="iframe" data-fancybox data-caption="" href="<?php echo LANG_URL . "siti/santa-barbara/download?start=" . $datestart . "&end=" . $dateend; ?>">
                            return <TimelinePart key={i}>
                              <TimelineFill 
                                onClick={() => setShowModalDoc(true)}
                                style={{"height": Math.floor(Math.random() * (Math.floor(Math.random() * 100)))}} 
                              />
                            </TimelinePart>;
                            
                          })}
                        </TimelineParts>
                        <TimelineMonthLabel>{month}</TimelineMonthLabel>
                      </TimelineMonth>
                    )}
                  </TimelineYear>
                </div>
              )}
            </Slider>
            <TimelineIndex>
              {ARR_YEARS.map((year, i) => 
                <TimelineIndexItem key={i} onClick={() => timelineSlider.slickGoTo(i)} active={year === timelineYear}>{year}</TimelineIndexItem>
              )}
            </TimelineIndex>
            
          </Container>

        </Timeline>
        <Container>

          <Row>
            <Col widthmd={3}>
              <DocsFolder href="#">Profilo amministrativo</DocsFolder>
              <DocsSubFolder href="#">Conferenze dei Servizi</DocsSubFolder>
              <DocsSubFolder href="#">Pareri tecnici</DocsSubFolder>
              <DocsSubFolder href="#">Decreti e Delibere</DocsSubFolder>
              <DocsSubFolder href="#">Certificazioni</DocsSubFolder>
              <DocsSubFolder href="#">Verbali</DocsSubFolder>
              <DocsSubFolder href="#">Validazioni</DocsSubFolder>
            </Col>
            <Col widthmd={3}>
              <DocsFolder href="#">Profilo ambientale</DocsFolder>
              <DocsSubFolder href="#">Acque superficiali</DocsSubFolder>
              <DocsSubFolder href="#">Aria</DocsSubFolder>
              <DocsSubFolder href="#">Biodiversità</DocsSubFolder>
              <DocsSubFolder href="#">Rumore</DocsSubFolder>
              <DocsSubFolder href="#">Vibrazioni</DocsSubFolder>
              <DocsSubFolder href="#">Campi elettromagnetici</DocsSubFolder>
              <DocsSubFolder href="#">Paesaggio</DocsSubFolder>
            </Col>
            <Col widthmd={3}>
              <DocsFolder href="#">Indagini ambientali</DocsFolder>
              <DocsSubFolder href="#">Piani di indagine</DocsSubFolder>
              <DocsSubFolder href="#">Piani di caratterizzazione</DocsSubFolder>
              <DocsSubFolder href="#">Report dei piani d’indagine eseguiti</DocsSubFolder>
            </Col>
            <Col widthmd={3}>
              <DocsFolder href="#">Attività di bonifica</DocsFolder>
              <DocsSubFolder href="#">Progetti di bonifica</DocsSubFolder>
              <DocsSubFolder href="#">Progetti di riqualificazione</DocsSubFolder>
              <DocsSubFolder href="#">Messe in sicurezza di emergenza</DocsSubFolder>
              <DocsSubFolder href="#">Messe in sicurezza operativa</DocsSubFolder>
            </Col>
          </Row>
          <Spacer />
          <center>
            <Button onClick={() => setShowModalDoc(true)}>Apri gestione documenti</Button>
            {showModalDoc ? 
              <FullModal onClose={() => setShowModalDoc(false)}>
                <Docs />
              </FullModal>
            : null}
          </center>
        </Container>
      </Band>

    </Layout>
  )
}

export default Sites
